import { createSlice } from "@reduxjs/toolkit";
import { menuItems } from "src/components/listing-detail/sticky-header/menu-items";

const initialState = {
  listingId: null,
  detailInfoModalOpened: false,
  selectedModalTab: "picture",
  stickyHeaderMenuItems: menuItems,
  messageModalOpened: false,
  shareModalOpened: false,
  reportListingModalOpened: false,
  detailInfoModalDirty: false,
  activeImageIndex: 0,
  odaPortalBoardUrl: null,
  selectedNearbyPoiInfo: null,
};

export const listingDetail = createSlice({
  name: "listingDetail",
  initialState,
  reducers: {
    setListingId: (state, action) => {
      state.listingId = action.payload;
    },
    handleDetailInfoModalOpened: (state, action) => {
      state.detailInfoModalDirty = true;
      state.detailInfoModalOpened = !state.detailInfoModalOpened;
      state.selectedModalTab = action.payload;
    },
    setStickyHeaderMenuItems: (state, action) => {
      state.stickyHeaderMenuItems = action.payload;
    },
    handleMessageModalOpened: (state, action) => {
      state.messageModalOpened = !state.messageModalOpened;
    },
    handleShareModalOpened: (state, action) => {
      state.shareModalOpened = !state.shareModalOpened;
    },
    handleReportModalOpened: (state, action) => {
      state.reportListingModalOpened = !state.reportListingModalOpened;
    },
    handleDetailInfoModalDirtyChange: (state, action) => {
      state.detailInfoModalDirty = true;
    },
    handleSetActiveImageIndex: (state, action) => {
      state.activeImageIndex = action.payload;
    },
    setOdaPortalBoardUrl: (state, action) => {
      state.odaPortalBoardUrl = action.payload;
    },
    setSelectedNearbyPoiInfo: (state, action) => {
      state.selectedNearbyPoiInfo = action.payload;
    },
  },
});

export const {
  setListingId,
  handleDetailInfoModalOpened,
  setStickyHeaderMenuItems,
  handleMessageModalOpened,
  handleShareModalOpened,
  handleReportModalOpened,
  handleSetActiveImageIndex,
  setOdaPortalBoardUrl,
  setSelectedNearbyPoiInfo,
} = listingDetail.actions;

export default listingDetail.reducer;
